/*
 * Copyright 2021 LABOR.digital
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Last modified: 2021.06.27 at 20:10
 */

import validator from 'validator';
// import countriesIso from 'i18n-iso-countries';

// const country = document.querySelector('#country');

let requesting = false;

window.openRegisterModal = () => {
	const underlay = document.querySelector('#underlay');
	const modal = document.querySelector('#modal');
	underlay.classList.add("is-open");
	modal.classList.add("is-open");
};

window.closeRegisterModal = () => {
	const underlay = document.querySelector('#underlay');
	const modal = document.querySelector('#modal');
	underlay.classList.remove("is-open");
	modal.classList.remove("is-open");
};

window.submitRegisterModal = () => {
	const first_name = document.querySelector('#first_name');
	const last_name = document.querySelector('#last_name');
	const email = document.querySelector('#email');
	const university = document.querySelector('#university');
	const country = document.querySelector('#country');

	let valid = true;

	if(validator.isEmpty(first_name.value.trim())) {
		first_name.invalid = true;
		first_name.valid = false;
		valid = false;
	} else  {
		first_name.invalid = false;
		first_name.valid = true;
	}
	if(validator.isEmpty(last_name.value.trim())) {
		last_name.invalid = true;
		last_name.valid = false;
		valid = false;
	} else  {
		last_name.invalid = false;
		last_name.valid = true;
	}
	if(validator.isEmpty(email.value.trim()) || !validator.isEmail(email.value.trim())) {
		email.invalid = true;
		email.valid = false;
		valid = false;
	} else  {
		email.invalid = false;
		email.valid = true;
	}
	if(validator.isEmpty(university.value.trim())) {
		university.invalid = true;
		university.valid = false;
		valid = false;
	} else  {
		university.invalid = false;
		university.valid = true;
	}

	if(validator.isEmpty(country.value.trim())) {
		country.classList.add('picker--error')
		valid = false;
	} else {
		country.classList.remove('picker--error')
	}

	if(valid && !requesting) {
		requesting = true;
		const overlay = document.querySelector('#register-overlay');
		overlay.classList.add('register-modal-wrapper--open')

		const http = new XMLHttpRequest();
		// http.open("POST", 'http://localhost:5001/adobe---aa-university/us-central1/register');
		http.open("POST", 'https://14257-bacomaaep.adobeio-static.net/api/v1/web/bacom-umep/register');
		s.setRequestHeader('Content-Type',
		'application/json')
		http.send(JSON.stringify({
			first_name: first_name.value.trim(),
			last_name: last_name.value.trim(),
			email: email.value.trim(),
			university: university.value.trim(),
			country: country.value.trim()
		}));

		http.onreadystatechange = (e) => {
			if(http.readyState === XMLHttpRequest.DONE) {
				var status = http.status;
				if (status === 0 || (status >= 200 && status < 400)) {
					overlay.classList.remove('register-modal-wrapper--open');
					location.href = "./post.html";
				} else {
					overlay.classList.remove('register-modal-wrapper--open');
					alert("Something went wrong. Please try again in a few moments.");
				}

				requesting = false;
			}
		}
	}

	console.log(email.value);
};